import { asText, Content, RichTextField } from '@prismicio/client';

import {
  Box,
  Badge,
  KeyContainer,
  ValueContainer,
  KeyValueWrapper,
} from '@preventx/oxygen';

type ProductMetadataProps = {
  id: string;
  title: RichTextField;
  metadata: Content.ProductDocumentDataProductMetadataItem[];
};

export const ProductMetadata = ({
  id,
  title,
  metadata,
}: ProductMetadataProps) => (
  <Box component="div">
    <KeyValueWrapper component="div">
      <KeyContainer component="div">{asText(title)}</KeyContainer>
      <ValueContainer component="div">
        <Box component="div" addCluster gap="gap-sm">
          {metadata.map(({ description }, index) => (
            <Badge variant="solid" key={`product-meta-data-${id}-${index + 1}`}>
              {asText(description)}
            </Badge>
          ))}
        </Box>
      </ValueContainer>
    </KeyValueWrapper>
  </Box>
);
